import { Button } from "components/DesignSystem/Button/Button";
import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";
import { COPIED_TEXT, FAILED_COPIED_TEXT } from "constants/documents";
import { useToast } from "hooks/useToast";
import { ConditionalLink } from "components/conditionalLink";
import ReferWhatsApp from "static/images/ReferWhatsApp.svg";
import ReferLinkedIn from "static/images/ReferLinkedIn.svg";
import ReferTwitter from "static/images/ReferTwitter.svg";
import ReferMail from "static/images/ReferMail.svg";
import ReferralDollarLeaf from "static/images/ReferralDollarLeaf.svg";
import { getSocialRedirctLinks } from "components/ReferHomeCard/ReferHomeCard";

export const ReferralBanner = () => {
  const {
    authtoken: { referral_link },
  } = useContext(authContext);
  const { alertToast, successToast } = useToast();

  const linkedInReferralLink = encodeURIComponent(referral_link);

  const mailLink = getSocialRedirctLinks({
    type: "mail",
    referralLink: referral_link,
  });
  const twitterLink = getSocialRedirctLinks({
    type: "twitter",
    referralLink: referral_link,
  });
  const linkedInLink = getSocialRedirctLinks({
    type: "linkedin",
    referralLink: linkedInReferralLink,
  });
  const whatsAppLink = getSocialRedirctLinks({
    type: "whatsapp",
    referralLink: referral_link,
  });

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(referral_link);
      successToast({ message: COPIED_TEXT });
    } catch (err) {
      alertToast({ message: FAILED_COPIED_TEXT });
    }
  };

  return (
    <div className="t-h-full t-min-h-[132px] t-w-full t-bg-surface-lighter-grey t-rounded-lg t-border t-border-solid t-border-neutral-10 t-flex t-flex-col t-gap-4 t-p-5 md:t-flex-row md:t-items-start md:t-justify-between">
      <div className="t-flex t-gap-3 t-items-start">
        <img
          className="t-h-8 t-w-8 t-object-cover"
          src={ReferralDollarLeaf}
          alt=""
        />
        <div className="t-flex t-flex-col t-gap-1">
          <div className="t-text-subtext t-text-text-100">
            Invite a founder, earn $100 each
          </div>
          <div className="t-text-body-sm t-text-text-30">
            Refer someone to Inkle. When they join, you both receive $100 in
            Inkle credits
          </div>
          <div className="t-flex t-gap-2 t-items-center t-mt-1">
            <div className="t-text-neutral t-text-body-sm">Share via:</div>
            <ConditionalLink to={mailLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img className="t-h-6 t-w-6" src={ReferMail} alt="Mail" />
              </Button>
            </ConditionalLink>
            <ConditionalLink to={twitterLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img className="t-h-6 t-w-6" src={ReferTwitter} alt="Twitter" />
              </Button>
            </ConditionalLink>
            <ConditionalLink to={linkedInLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img
                  className="t-h-6 t-w-6"
                  src={ReferLinkedIn}
                  alt="LinkedIn"
                />
              </Button>
            </ConditionalLink>
            <ConditionalLink to={whatsAppLink}>
              <Button customType="ghost_icon" size="xsmall">
                <img
                  className="t-h-6 t-w-6"
                  src={ReferWhatsApp}
                  alt="WhatsApp"
                />
              </Button>
            </ConditionalLink>
          </div>
        </div>
      </div>
      <Button
        size="small"
        onClick={copyToClipBoard}
        className="t-self-start md:t-self-auto"
      >
        Copy link
      </Button>
    </div>
  );
};
